module.exports = __webpack_public_path__ + "static/media/VestasSans-Bold.9f0d3ec2.svg";